import React, { useState } from 'react';
import { Container, Form, Button, Row, Col, Alert,Spinner } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { postDataLogin } from '../ApiServices/ApiService';
import { useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa'; 

import LoginNav from './LoginNav';
import FooterPage from './FooterPage';

const ContactPage = () => {
  const navigate = useNavigate();
  const [candidate, setCandidate] = useState({
    name: '',
    email: '',
    countryCode: '+1',
    phoneNumber: '',
    message:''
  });


  const handleSubmit =async (e)=>{
    e.preventDefault();
    console.log("candidate",candidate)
  }
  const handleChange =(e)=>{
    const { name, value } = e.target;
    setCandidate((prevCandidate) => ({
      ...prevCandidate,
      [name]: value,
    }));
  }
  const numberChange =(event)=>{
    const inputValue = event.target.value;
  if (!/[A-Z!@#$%^&*()_+{}\[\]:;<>,.?~=/\\-]/.test(inputValue) && !/[a-z]/.test(inputValue)) {
    const { name, value } = event.target;
    setCandidate((prevCandidate) => ({
      ...prevCandidate,
      [name]: value,
    }))
    
  }
  else {
    // event.preventDefault();
   
  }
  }

  return (
    <>
    <LoginNav></LoginNav>
    
    <div className="background-container" style={{overflowX:'hidden',marginBottom:'30px'}}>
      <div>
    <h1 className='login-heading'>Contact Us</h1></div>
    <h2  className='login-heading'>We would love to hear from you.</h2>

   
    <div className="row" style={{textAlign:'left',marginLeft: '60px',marginBottom:'15px'}}>
    <div className='col-md-8 col-12 col-lg-6'>
    <div className="contactus-div">
    <h3 style={{fontWeight:'normal',fontSize:'15px',paddingBottom:'10px'}}>Write to us if you have an inquiry, comment or would like to know more about our technology solutions.</h3>
      <Form noValidate  onSubmit={handleSubmit}>
      <div className='screen-styling'>
        <Form.Group controlId="formName" style={{ marginBottom: '10px',marginRight:'8px',width:'100%' }} >
          <Form.Control
            type="text"
            name="name"
            placeholder="Enter Name*"
            value={candidate.name}
            onChange={handleChange}
            required
          />
          <Form.Control.Feedback type="invalid">Please Enter A Name.</Form.Control.Feedback>
        </Form.Group>

        <Form.Group controlId="formEmail" style={{ marginBottom: '10px',width:'100%' }} xs={6} md={12}>
          <Form.Control
            type="email"
            name="email"
            placeholder="Enter Email*"
            value={candidate.email}
            onChange={handleChange}
            required
          />
          <Form.Control.Feedback type="invalid">Please Enter A Valid Email Address.</Form.Control.Feedback>
        </Form.Group>
        </div>
        <Form.Group controlId="formPhoneNumber" style={{ marginBottom: '10px',width:'100%'  }} >
        <Row>
          <Col xs={4} style={{ paddingRight: '0px' }}>
            <Form.Control
              as="select"
              name="countryCode"
              value={candidate.countryCode}
              onChange={handleChange}
              required
            >
              {/* Options for country codes */}
              <option value="+1">+1 (USA)</option>
              <option value="+91">+91 (India)</option>
              {/* Add more country codes as needed */}
            </Form.Control>
            <Form.Control.Feedback type="invalid">Please Select A Country Code.</Form.Control.Feedback>
          </Col>
          <Col xs={8} style={{ paddingLeft: '10px' }}>
            <Form.Control
              type="text"
              name="phoneNumber"
              value={candidate.phoneNumber}
              onChange={numberChange}
              placeholder="Enter Phone Number"
              maxLength={10}
              // required
            />
            <Form.Control.Feedback type="invalid">Please Enter Phone Number.</Form.Control.Feedback>
          </Col>
        </Row>
      </Form.Group>
      <Form.Group as={Col} xs={12} style={{ marginBottom: '10px',marginTop:'15px' }}>
          <Form.Control as="textarea" rows={3} onChange={handleChange} name="message" value={candidate.message} placeholder='Message' required />
          <Form.Control.Feedback type="invalid">Please Write the Message.</Form.Control.Feedback>
        </Form.Group>
      
     
    
        <button type="submit" variant="dark" className="contact-button">Submit</button>

      </Form>
      </div>
      </div>
      <div className='col-md-4 col-12 col-lg-6' style={{display:'flex',justifyContent:'center'}}>
        <div className='com-details'>
          <h4>Our Office Address</h4>
          {/* <div>
            <h5>INDIA</h5>
            <small>Datalake solutions
              <br />2nd Floor, JQ Chambers<br/>Jayabheri Enclave, Gachibowli<br/>Hyderabad, Telangana 500032
            </small>
          </div>
          <div>
            <h5>USA</h5>
            <small>800, North High Street,5th fl<br/>Columbus Ohio 43215</small>
          </div>
          <div>
            <h5>Help Desk</h5>
            <small>connect@your-buddy.com</small>
          </div>
          <div>
            <h5>Have any querry:</h5>
            <small>(+1) 614 218 8735<br/>(+91) 08037835306
            </small>
          </div> */}
          <ul style={{listStyle:'none',paddingLeft:'0px'}}>
            <li style={{marginBottom:'25px'}}>
              <strong>INDIA</strong><br/>
              Datalake Solutions
              <br />2nd Floor, JQ Chambers<br/>Jayabheri Enclave, Gachibowli<br/>Hyderabad, Telangana 500032
            </li>
            <li style={{marginBottom:'25px'}}>
              <strong>USA</strong><br/>
              800, North High Street,5th fl<br/>Columbus Ohio 43215
            </li>
            <li style={{marginBottom:'25px'}}>
              <strong>Help Desk</strong><br/>
              connect@your-buddy.com
            </li>
            <li style={{marginBottom:'25px'}}>
              <strong>Have any querry:</strong><br/>
              (+1) 614 218 8735<br/>(+91) 08037835306
            </li>
          </ul>
        </div>
      </div>
    </div>

    </div>
    <FooterPage></FooterPage>
    </>
  
       
     
  );
};

export default ContactPage